import React from "react";

const LoadingSpinner = ({ isLoading }) => {
  return (
    <>
      {isLoading && (
        <div className="spinner-container d-flex justify-content-center">
          <div
            className={`spinner-grow text-primary fade-out ${!isLoading ? "hide" : ""}`}
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          />
        </div>
      )}
    </>
  );
};

export default LoadingSpinner;